<template lang="pug">
.searchResults-item
	.searchResults-itemContent
		.searchResults-itemMeta
			.searchResults-itemMetaTag(:class="'searchResults-itemMetaTag--' + returnTypeClassSuffix(result.meta.type)") {{ result.meta.type }}
			.searchResults-itemMetaDate {{ date }}
		a.searchResults-itemContentTitle(:href="result.url") {{ result.title }}
		.searchResults-itemContentSummary {{ result.summary }}
</template>

<script>
export default {
	name: "OCCResult",
	props: {
		result: Object,
		openInNewWindow: Boolean,
		formatDate: Function,
	},
	computed: {
		date() {
			// check for May
			return new Date(this.result.itemDate).getMonth() !== 4 ? this.formatDate(this.result.itemDate, "MMM. dd, yyyy") : this.formatDate(this.result.itemDate, "MMM dd, yyyy")
		},
	},
	methods: {
		returnTypeClassSuffix(str) {
			if (str.toLowerCase() === "insights") return "blog";
			let arr = str.toLowerCase().split(" ");
			arr.forEach((word, i) => {
				if (i !== 0) {
					let firstLetter = word[0].toUpperCase();
					let newWord = firstLetter + word.slice(1, word.length);
					arr[i] = newWord;
				}
			})
			return arr.join("");
		}
	},
	mounted() {
		// console.log(this.result)
	}
};
</script>

<style lang="scss" scoped>
.searchResults {
	&-item {
		&Meta {
			&Date {
				font-size: 11px;
			}
		}
	}
	&-itemContent {
		&Summary {
			font-size: 14px;
		}
	}
}
</style>